import React, { useContext} from "react";
import { Link } from "react-router-dom";
import { TaskContext } from '../../context/TaskContext'

import "./footer.css";
export function Footer(){
  return (
    <footer className="container-footer" style={{ userSelect: 'none', WebkitUserSelect: 'none' }}>
      <div className="div-footer">
       <h4 id="title_footer">[Copyright: © 2023/19/08 | Droommk12]</h4>
        <p id="paragraph_footer">C M I</p>
      </div><hr />
    </footer>
  );
}

export function FooterAndButon(){
  const  reloj = useContext(TaskContext);
  const hiperAncle = { textDecoration: "none" };
  function ScrollToTop(){window.scrollTo(0, 0);}
  return (
    <footer className="container-footer" lang="es" style={{ userSelect: 'none', WebkitUserSelect: 'none' }} >
      <div className="div-footer">
        <h4 id="title_footer">[Copyright: © 2023/19/08 | Droommk12]</h4>
        <p id="paragraph_footer">C M I</p>
        <div id="link_footer">
          <Link to={"/"}><button id="button_footer" style={hiperAncle} >VOLVER PAGINA PRINCIPAL</button></Link>
          <Link onClick={ScrollToTop}><button id="__button_footer_two" style={hiperAncle}>ARRIBA</button></Link>
        </div>
        <p id="paragraph_footer__time" >Hora - { reloj.hora.toLocaleTimeString() }{" "}</p>
      </div><hr />
    </footer>
  );
}
